module.exports = __webpack_public_path__ + "img/224.4f1d84c7.png";